import {
  GET_PROSPECTS_REQUEST,
  GET_PROSPECTS_SUCCESS,
  GET_PROSPECTS_FAILED,
  POST_GENERATE_ROUTE_REQUEST,
  POST_GENERATE_ROUTE_SUCCESS,
  POST_GENERATE_ROUTE_FAILURE,
} from './actionTypes';

export const prospectsRequest = () => ({ type: GET_PROSPECTS_REQUEST });
export const prospectsSuccess = (data, meta) => ({ type: GET_PROSPECTS_SUCCESS, data, meta });
export const prospectsFailure = (error) => ({ type: GET_PROSPECTS_FAILED, error });

export const postGenerateRouteRequest = () => ({ type: POST_GENERATE_ROUTE_REQUEST });
// eslint-disable-next-line max-len
export const postGenerateRouteSuccess = (success) => ({ type: POST_GENERATE_ROUTE_SUCCESS, success });
export const postGenerateRouteFailure = (error) => ({ type: POST_GENERATE_ROUTE_FAILURE, error });
